export const CART_PAGEVIEW = 'CART_PAGEVIEW';
export const EVENT_CART_QUANTITY = 'EVENT_CART_QUANTITY';
export const EVENT_NAVIGATE_TO_CHECKOUT = 'EVENT_NAVIGATE_TO_CHECKOUT';
export const EVENT_ADD_TO_CART = 'EVENT_ADD_TO_CART';
export const EVENT_MODIFY_QUANTITY = 'EVENT_MODIFY_QUANTITY';
export const EVENT_REMOVE_FROM_CART = 'EVENT_REMOVE_FROM_CART';
export const EVENT_CART_HEAD_BANNER_CLICK = 'EVENT_CART_HEAD_BANNER_CLICK';
export const EVENT_CART_CONTINUE_SHOPPING_CLICK = 'EVENT_CART_CONTINUE_SHOPPING_CLICK';
export const EVENT_VIEW_CART_CLICK = 'EVENT_VIEW_CART_CLICK';
export const EVENT_CART_MODAL_CLOSE = 'EVENT_CART_MODAL_CLOSE';
export const EVENT_CART_RECO_CLICK = 'EVENT_CART_RECO_CLICK';
